import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    name: 'Cloche LED industrielle 240W',
    code: 'CLI240W-CEE',
    mainImage: 'https://public.readdy.ai/ai/img_res/6342fbd1ba4fe30d9cefdc8df80cf633.jpg',
    hasTechnicalSheet: true,
    technicalSheetUrl: 'https://econegoce.com/wp-content/uploads/2025/05/Eclairage-LED-cloche.pdf',
    specs: [
      { label: 'Flux lumineux', value: '44 400 lm' },
      { label: 'Efficacité', value: '185 lm/W' },
      { label: 'LED', value: 'SMD 2835' },
      { label: 'IRC', value: '80' },
      { label: 'Étanchéité', value: 'IP65' },
      { label: 'Résistance', value: 'IK08' },
      { label: 'Variation', value: '0-10V' },
      { label: 'Capteur', value: 'Intégré' },
      { label: 'Durée de vie', value: '50 000h' },
      { label: 'Garantie', value: '5 ans' },
    ],
    applications: [
      'Entrepôts et plateformes logistiques',
      'Usines et ateliers de production',
      'Grandes hauteurs (6m à 15m)',
      'Zones de stockage intensif',
      'Halls industriels'
    ]
  },
  {
    id: 2,
    name: 'Réglette LED industrielle 240W',
    code: 'RLI240-CEE',
    mainImage: 'https://readdy.ai/api/search-image?query=industrial%20LED%20linear%20light%20fixture%20240W%20rectangular%20luminaire%20on%20pure%20white%20background%20dramatic%20studio%20lighting%20showing%20sleek%20aluminum%20housing%20professional%20product%20photography%20ultra%20sharp%208k%20minimalist%20simple%20background&width=800&height=800&seq=product-linear-main-006&orientation=squarish',
    hasTechnicalSheet: true,
    technicalSheetUrl: 'https://econegoce.com/wp-content/uploads/2025/05/Eclairage-LED-reglette.pdf',
    specs: [
      { label: 'Efficacité', value: '185 lm/W' },
      { label: 'Driver', value: 'Sosen' },
      { label: 'Optiques', value: 'Multiples' },
      { label: 'Angles', value: '45°, 60x90°, 70°' },
      { label: 'Étanchéité', value: 'IP65' },
      { label: 'Résistance', value: 'IK08' },
      { label: 'Variation', value: '0-10V' },
      { label: 'Type', value: 'Type 2/3/4' },
      { label: 'Durée de vie', value: '50 000h' },
      { label: 'Garantie', value: '5 ans' },
    ],
    applications: [
      'Allées de rayonnages et picking',
      'Plateformes logistiques',
      'Installations sportives',
      'Commerce de détail industriel',
      'Zones de circulation'
    ]
  },
  {
    id: 3,
    name: 'Télécommande intelligente',
    code: 'TCI-SMART',
    mainImage: 'https://readdy.ai/api/search-image?query=modern%20industrial%20LED%20remote%20control%20device%20sleek%20black%20design%20with%20digital%20display%20and%20adjustment%20buttons%20on%20clean%20white%20background%20professional%20product%20photography%20ultra%20sharp%208k%20minimalist%20simple%20background%20studio%20lighting&width=800&height=800&seq=smart-remote-control-main-001&orientation=squarish',
    hasTechnicalSheet: false,
    specs: [
      { label: 'Intensité', value: '20% à 100%' },
      { label: 'Niveaux', value: '160/180/200 lux' },
      { label: 'Mode', value: 'Automatique' },
      { label: 'Portée', value: 'Jusqu\'à 30m' },
      { label: 'Alimentation', value: 'Batterie' },
      { label: 'Durée', value: '2 ans' },
      { label: 'Compatibilité', value: 'Universelle' },
      { label: 'Installation', value: 'Plug & Play' },
      { label: 'Garantie', value: '2 ans' },
      { label: 'Certification', value: 'CE' },
    ],
    applications: [
      'Ajustement selon la hauteur',
      'Contrôle de la luminosité',
      'Adaptation à l\'usage',
      'Gestion multi-zones',
      'Programmation horaire'
    ]
  },
  {
    id: 4,
    name: 'Capteur de mouvement intégré',
    code: 'CMI-AUTO',
    mainImage: 'https://readdy.ai/api/search-image?query=industrial%20motion%20sensor%20device%20modern%20white%20design%20with%20detection%20lens%20and%20LED%20indicator%20on%20clean%20white%20background%20professional%20product%20photography%20ultra%20sharp%208k%20minimalist%20simple%20background%20studio%20lighting&width=800&height=800&seq=motion-sensor-main-001&orientation=squarish',
    hasTechnicalSheet: false,
    specs: [
      { label: 'Détection', value: 'Infrarouge' },
      { label: 'Portée', value: 'Jusqu\'à 12m' },
      { label: 'Angle', value: '360°' },
      { label: 'Délai', value: 'Réglable' },
      { label: 'Sensibilité', value: 'Ajustable' },
      { label: 'Étanchéité', value: 'IP65' },
      { label: 'Installation', value: 'Intégré' },
      { label: 'Économies', value: 'Jusqu\'à 80%' },
      { label: 'Garantie', value: '3 ans' },
      { label: 'Certification', value: 'CE' },
    ],
    applications: [
      'Allumage automatique',
      'Ajustement selon l\'activité',
      'Réduction des consommations',
      'Zones de passage',
      'Espaces intermittents'
    ]
  }
];

export default function ProductDetails() {
  const handleTechnicalSheet = (url: string, productName: string) => {
    if (url === '#') {
      alert(`La fiche technique de ${productName} sera bientôt disponible au téléchargement.`);
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <section className="py-8 sm:py-12 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-12">
        <div className="space-y-8 sm:space-y-12 lg:space-y-16">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              initial={window.innerWidth >= 768 ? { opacity: 0, y: 30 } : {}}
              whileInView={window.innerWidth >= 768 ? { opacity: 1, y: 0 } : {}}
              viewport={window.innerWidth >= 768 ? { once: true } : {}}
              transition={window.innerWidth >= 768 ? { duration: 0.6 } : {}}
              className="group"
              data-product-shop
            >
              <div className="flex flex-col lg:grid lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 items-center">
                {/* Image Section */}
                <div className={`w-full ${index % 2 === 1 ? 'lg:col-start-2 lg:order-2' : 'lg:order-1'}`}>
                  <div className="relative bg-gradient-to-br from-slate-50 via-white to-slate-50 rounded-lg sm:rounded-xl lg:rounded-2xl p-3 sm:p-6 lg:p-8 shadow-sm sm:shadow-lg border border-slate-100 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/5 to-teal-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ opacity: window.innerWidth >= 768 ? undefined : 0 }}></div>
                    
                    <div className="relative w-full h-32 sm:h-48 lg:h-72">
                      <img
                        src={product.mainImage}
                        alt={product.name}
                        className="w-full h-full object-contain object-center transform transition-transform duration-700"
                        style={{ transform: window.innerWidth >= 768 ? undefined : 'none' }}
                      />
                    </div>

                    {/* Badge */}
                    <div className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-[10px] sm:text-xs font-bold shadow-lg">
                      Conforme BAT-EQ-127
                    </div>
                  </div>
                </div>

                {/* Content Section */}
                <div className={`w-full ${index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1 lg:order-1' : 'lg:order-2'}`}>
                  <div className="space-y-3 sm:space-y-4 lg:space-y-5">
                    {/* Header */}
                    <div>
                      <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-slate-900 mb-1 sm:mb-1.5 leading-tight">
                        {product.name}
                      </h2>
                      <p className="text-[10px] sm:text-xs font-mono text-emerald-600 tracking-wider">{product.code}</p>
                    </div>

                    {/* Specs Grid - Ultra Compact pour mobile */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5 sm:gap-2">
                      {product.specs.slice(0, 6).map((spec, idx) => (
                        <motion.div
                          key={idx}
                          initial={window.innerWidth >= 768 ? { opacity: 0, scale: 0.9 } : {}}
                          whileInView={window.innerWidth >= 768 ? { opacity: 1, scale: 1 } : {}}
                          viewport={window.innerWidth >= 768 ? { once: true } : {}}
                          transition={window.innerWidth >= 768 ? { duration: 0.3, delay: idx * 0.03 } : {}}
                          className="bg-white rounded-md sm:rounded-lg p-2 sm:p-3 border border-slate-200 transition-all duration-300"
                          style={{ 
                            borderColor: window.innerWidth >= 768 ? undefined : 'rgb(226 232 240)',
                            boxShadow: window.innerWidth >= 768 ? undefined : 'none'
                          }}
                        >
                          <p className="text-[9px] sm:text-xs uppercase text-slate-500 mb-0.5 tracking-wide font-medium">
                            {spec.label}
                          </p>
                          <p className="text-[11px] sm:text-sm font-bold text-slate-900 leading-tight">
                            {spec.value}
                          </p>
                        </motion.div>
                      ))}
                    </div>

                    {/* Applications - Ultra Compact */}
                    <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-lg sm:rounded-xl p-3 sm:p-4 border border-emerald-100">
                      <h3 className="text-sm sm:text-base font-bold text-slate-900 mb-2 sm:mb-3 flex items-center">
                        <div className="w-4 h-4 sm:w-6 sm:h-6 rounded-full bg-emerald-500 flex items-center justify-center mr-1.5 sm:mr-2">
                          <i className="ri-lightbulb-line text-white text-[10px] sm:text-xs"></i>
                        </div>
                        Applications idéales
                      </h3>
                      <ul className="grid grid-cols-1 gap-1.5 sm:gap-2">
                        {product.applications.slice(0, 3).map((app, idx) => (
                          <li key={idx} className="flex items-start space-x-1.5 sm:space-x-2">
                            <div className="w-3 h-3 sm:w-5 sm:h-5 rounded-full bg-emerald-500 flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm">
                              <i className="ri-check-line text-white text-[8px] sm:text-xs"></i>
                            </div>
                            <span className="text-[10px] sm:text-xs text-slate-700 leading-relaxed font-medium">{app}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* CTA Buttons - Compacts pour mobile */}
                    <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                      {product.hasTechnicalSheet && (
                        <button
                          onClick={() => handleTechnicalSheet(product.technicalSheetUrl, product.name)}
                          className="inline-flex items-center justify-center space-x-1.5 sm:space-x-2 bg-white text-emerald-600 border-2 border-emerald-500 px-4 py-2.5 sm:px-6 sm:py-3 rounded-full text-xs sm:text-sm font-bold transition-all duration-300 cursor-pointer whitespace-nowrap group"
                          style={{ 
                            backgroundColor: window.innerWidth >= 768 ? undefined : 'white',
                            transform: window.innerWidth >= 768 ? undefined : 'none'
                          }}
                        >
                          <i className="ri-download-line text-xs sm:text-base transition-transform" style={{ transform: window.innerWidth >= 768 ? undefined : 'none' }}></i>
                          <span>Fiche technique PDF</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Divider */}
              {index < products.length - 1 && (
                <div className="mt-8 sm:mt-12 lg:mt-16 border-t border-slate-200"></div>
              )}
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={window.innerWidth >= 768 ? { opacity: 0, y: 30 } : {}}
          whileInView={window.innerWidth >= 768 ? { opacity: 1, y: 0 } : {}}
          viewport={window.innerWidth >= 768 ? { once: true } : {}}
          transition={window.innerWidth >= 768 ? { duration: 0.6, delay: 0.2 } : {}}
          className="mt-8 sm:mt-16 lg:mt-20 text-center"
        >
          <div className="bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-2xl max-w-4xl mx-auto">
            <h3 className="text-xl sm:text-3xl font-black text-white mb-2 sm:mb-3">
              Prêt à optimiser votre éclairage ?
            </h3>
            <p className="text-emerald-50 mb-4 sm:mb-6 text-xs sm:text-base">
              Découvrez nos services complets ou demandez votre étude personnalisée gratuite
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
              <Link
                to="/nos-services"
                className="inline-flex items-center justify-center gap-2 bg-white text-emerald-600 font-bold py-2.5 sm:py-3 px-6 sm:px-8 rounded-lg hover:bg-emerald-50 transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap text-sm sm:text-base w-full sm:w-auto"
              >
                <i className="ri-tools-line text-base sm:text-lg"></i>
                <span>Découvrir nos services</span>
              </Link>
              
              <Link
                to="/etude-gratuite"
                className="inline-flex items-center justify-center gap-2 bg-white text-emerald-600 font-bold py-2.5 sm:py-3 px-6 sm:px-8 rounded-lg hover:bg-emerald-50 transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap text-sm sm:text-base w-full sm:w-auto"
              >
                <i className="ri-file-list-3-line text-base sm:text-lg"></i>
                <span>Demander une étude gratuite</span>
              </Link>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 mt-4 sm:mt-6 text-emerald-50 text-[10px] sm:text-xs">
              <div className="flex items-center gap-1.5">
                <i className="ri-time-line text-xs sm:text-sm"></i>
                <span>Réponse garantie en 24h</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-emerald-200 rounded-full"></div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-xs sm:text-sm"></i>
                <span>Audit sur site inclus</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
